module.exports = __webpack_public_path__ + "static/img/szafa_27.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/szafa/_kopia/szafa_27.jpg
// module id = 1yQC
// module chunks = 0